if (!customElements.get('featured-reviews')) {
  customElements.define(
    'featured-reviews',
    class FeaturedReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-featured-reviews-track]');
        this.slides = Array.from(this.querySelectorAll('[data-featured-review-slide]'));
        this.previousButton = this.querySelector('[data-featured-reviews-previous]');
        this.nextButton = this.querySelector('[data-featured-reviews-next]');
        this.dots = Array.from(this.querySelectorAll('[data-featured-reviews-dot]'));
        this.currentIndex = 0;

        if (!this.track || !this.slides.length) return;

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.featuredReviewsDot)));
        });

        let scrollFrame;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(scrollFrame);
            scrollFrame = requestAnimationFrame(() => {
              const currentIndex = this.slides.reduce((closestIndex, slide, index) => {
                const firstSlideOffset = this.slides[0].offsetLeft;
                const currentDistance = Math.abs(
                  this.slides[closestIndex].offsetLeft - firstSlideOffset - this.track.scrollLeft
                );
                const slideDistance = Math.abs(slide.offsetLeft - firstSlideOffset - this.track.scrollLeft);
                return slideDistance < currentDistance ? index : closestIndex;
              }, 0);
              this.setCurrent(currentIndex);
            });
          },
          { passive: true }
        );

        this.querySelectorAll('[data-review-toggle]').forEach((button) => {
          const copy = button.closest('.featured-review-card__copy');
          const text = copy?.querySelector('[data-review-copy]');
          if (!copy || !text) return;

          requestAnimationFrame(() => {
            const hasHiddenText = text.scrollHeight > text.clientHeight + 2;
            button.hidden = !hasHiddenText;
            button.classList.toggle('is-visible', hasHiddenText);
          });

          button.addEventListener('click', () => {
            const expanded = !copy.classList.contains('is-expanded');
            this.querySelectorAll('.featured-review-card__copy').forEach((reviewCopy) => {
              reviewCopy.classList.toggle('is-expanded', expanded);
            });
            this.querySelectorAll('[data-review-toggle].is-visible').forEach((toggle) => {
              toggle.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
            });
          });
        });

        this.querySelectorAll('[data-review-image-open]').forEach((button) => {
          const card = button.closest('[data-featured-review-slide]');
          const modal = card?.querySelector('[data-review-image-modal]');
          const closeButton = modal?.querySelector('[data-review-image-close]');
          if (!modal || typeof modal.showModal !== 'function') return;

          button.addEventListener('click', () => modal.showModal());
          closeButton?.addEventListener('click', () => modal.close());
          modal.addEventListener('click', (event) => {
            if (event.target === modal) modal.close();
          });
        });

        this.setCurrent(0);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const left = this.slides[nextIndex].offsetLeft - this.slides[0].offsetLeft;
        this.track.scrollTo({ left, behavior: 'smooth' });
        this.setCurrent(nextIndex);
      }

      setCurrent(index) {
        this.currentIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
